import { useQuery } from "@tanstack/react-query";
import BookingService from "../services";
import { SortField } from "../../../utils/schema/SortType";
import qs from "qs";
import { BookingsFilterValues } from "../../../utils/schema/BookingFiltersType";

interface UseBookingsParams {
  sortFields?: SortField[];
  page?: number;
  rowsPerPage?: number;
  filters?: BookingsFilterValues | any;
  searchText?: string;
}

export const useBookings = ({
  sortFields,
  page,
  rowsPerPage,
  filters,
  searchText,
}: UseBookingsParams = {}) => {
  
  const sortParam = sortFields
    ? sortFields.map(({ field, order }) => `${field}:${order}`)
    : undefined;

  const query = qs.stringify(
    {
      sort: sortParam,
      pagination: {
        page,
        pageSize: rowsPerPage,
      },
      populate: {
        event: {
          populate: "*", 
        },
        players: {
          populate: "*", 
        },
        exhibitor: "*",
      },
      filters: searchText
      ? {
          ...filters,
          event: { name: { $contains: searchText } },
        }
      : filters,
    },
    { encodeValuesOnly: true }
  );
  return useQuery({
    queryKey: ["bookings", query],
    queryFn: () => BookingService.getAll({ query }),
    // keepPreviousData: true,
  });
};
